import { render } from "./BodySegmentsView.vue?vue&type=template&id=3185fd6b&scoped=true"
const script = {}

import "./BodySegmentsView.vue?vue&type=style&index=0&id=3185fd6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3185fd6b"]])

export default __exports__